export default "__VITE_ASSET__df2f8681__"